import React from "react";
import Section from "../Section/section";
import withMediaQueries from "../../../hoc/withMediaQueries";
import PropTypes from "prop-types";
import moneyFormatter from "money-formatter";


export const LoanExample = (props) => {
  const { screenSizeUtils, campaignData } = props;
  const { mediaQueriesList, screenLargerThan } = screenSizeUtils;

  const pClassName = "font-weight-light".concat(screenLargerThan(mediaQueriesList.md) ? ' h1' : ' h3');
  return (
    <Section
      name="loan-example"
      header="Here’s an example."
      subHeader="Barclays Personal Loan – a quick snapshot.">
      <div id="loan-example-container" className={"container card bottom-shadow".concat(screenLargerThan(mediaQueriesList.xs) ? ' p-5' : ' p-2')}>
        <div className="row text-center text-barclays-secondary-dark-cyan mt-0 pt-4">
          <div className="col-12 col-sm-4">
            <p className={pClassName}>$10,000</p>
            <small className="grey-text">Loan amount</small>
          </div>
          <div className="col-12 col-sm-1">
            <p className="h3 text-muted">@</p>
          </div>
          <div className="col-12 col-sm-3">
            <p className={pClassName}>5.99%</p>
            <small className="grey-text">APR</small>
          </div>
          <div className="col-12 col-sm-1">
            <p className="h3 text-muted">=</p>
          </div>
          <div className="col-12 col-sm-3">
            <p className={pClassName}>$236</p>
            <small className="grey-text">Monthly payment <br/> over 48 months</small>
          </div>
        </div>
        <div id="loan-example-legend" className={"my-4 mx-auto".concat(screenLargerThan(mediaQueriesList.xxs) ? ' w-75': '')}>
          <hr/>
          <small className="text-muted mt-5 d-inline-block text-center m-auto">The above example is for illustration
            purpose only. Barclays Bank Delaware offers loans from {moneyFormatter.format('USD', campaignData.minLoanAmount, 0)} – {moneyFormatter.format('USD', campaignData.maxLoanAmount, 0)} with flexible terms of 36, 48, and
            60
            months and APRs ranging from {campaignData.minApr}% – {campaignData.maxApr}%. Your approved loan amount and APR will be based on your
            creditworthiness and length of term requested.
          </small>
        </div>
      </div>
    </Section>
  );
};

LoanExample.propTypes = {
  screenSizeUtils: PropTypes.shape({
    mediaQueriesList: PropTypes.object.isRequired,
    screenLargerThan: PropTypes.func.isRequired
  }).isRequired
};

export default withMediaQueries(LoanExample);
